const Menu = [
    {
      id: 1,
      image: "images/maggi.jpg",
      name: "maggi",
      category: "breakfast",
      price: "40₹",
      description:
        "Goodness of Iron in every pack of MAGGI 2-Minute Masala Noodles. Both veg and non-veg available ",
    },
  
    {
      id: 2,
      image: "images/Alu_Pakoda.jpg",
      name: "Bread Pakora",
      category: "breakfast",
      price: "25₹",
      description:
        "Bread Pakora is a much loved snack of deep fried and savory bread fritters from the North Indian Cuisine.",
    },
    {
      id: 3,
      image: "images/corn.jpg",
      name: "corn",
      category: "breakfast",
      price: "15₹",
      description:
        "Corn is the third largest plant-based food source in the world, and high in dietary fibre and rich in antioxidants. ",
    },
    {
      id: 4,
      image: "../images/Chhole_Bhatoore.jpg",
      name: "Chhole Bhature",
      category: "lunch",
      price: "60₹",
      description:
        "Chickpea Curry with Fried Flatbreads.",
    },
    {
      id: 5,
      image: "../images/rajmarice.jpg",
      name: "Rajma Chawal",
      category: "lunch",
      price: "90₹",
      description:
        "Our best food Rajma Chawal, healthy and tasty Rajma Chawal. ",
    },
    {
      id: 6,
      image: "../images/pizza.jpg",
      name: "pizza",
      category: "evening",
      price: "89₹",
      description:
        "pizza, dish of Italian origin consisting of a flattened disk of bread dough topped with some combination of olive oil, oregano, tomato, olives, mozzarella or other cheese, and many other ingredients.",
    },
    {
      id: 7,
      image: "../images/nonvegthali.jpg",
      name: "Non-Veg Thali",
      category: "dinner",
      price: "580₹",
      description:
        "Premium meal( 4-tandoori roti, rice, rayta, 3-dishes",
    },
    {
      id: 8,
      image: "../images/sweet.jpg",
      name: "Sweets",
      category: "dinner",
      price: "260₹/kg",
      description:
        "Rasgulla: One of India's most famous sweet, minimum order 1kg",
    },
    
    {
      id: 9,
      image: "../images/samosa.jpg",
      name: "samosa",
      category: "evening",
      price: "10₹",
      description:
        "Delicious Samosa: three types are available, different rates for different types.",
    },
  ];
  
  export default Menu;